module.exports = __webpack_public_path__ + "static/media/duckcreekLogo3.1565c995.png";